import type { IconKey } from '../icons'
import type { Role } from '../../types'

export interface NavItem {
  key: string
  to: string
  label: string
  icon: IconKey
  count?: number
}

export interface NavGroup {
  grp: string
  items: NavItem[]
}

export interface NavCounts {
  brands?: number
  accounts?: number
  vcards?: number
}

/**
 * Rollenabhängige SideNav-Struktur (Spiegel des Dummy `navConfig()`), als reine
 * Datenfunktion — dadurch unabhängig testbar. Icons werden erst in <SideNav/>
 * aus dem IconKey aufgelöst.
 */
export function navConfig(role: Role, counts: NavCounts = {}): NavGroup[] {
  if (role === 'admin') {
    return [
      { grp: 'Übersicht', items: [{ key: 'dashboard', to: '/admin/dashboard', label: 'Dashboard', icon: 'dash' }] },
      {
        grp: 'Verwaltung',
        items: [
          { key: 'brands', to: '/admin/brands', label: 'Brands', icon: 'brand', count: counts.brands },
          { key: 'accounts', to: '/admin/accounts', label: 'Nutzer', icon: 'users', count: counts.accounts },
          { key: 'vcards', to: '/admin/vcards', label: 'vCards', icon: 'card', count: counts.vcards },
          { key: 'domains', to: '/admin/domains', label: 'Domains', icon: 'domains' },
        ],
      },
    ]
  }
  if (role === 'brand-admin') {
    return [
      { grp: 'Übersicht', items: [{ key: 'dashboard', to: '/admin/dashboard', label: 'Dashboard', icon: 'dash' }] },
      {
        grp: 'Meine Brand',
        items: [
          { key: 'brand', to: '/admin/brand', label: 'Brand-Profil', icon: 'brand' },
          { key: 'accounts', to: '/admin/accounts', label: 'Nutzer', icon: 'users', count: counts.accounts },
          { key: 'vcards', to: '/admin/vcards', label: 'vCards', icon: 'card', count: counts.vcards },
        ],
      },
    ]
  }
  // user hat keine Admin-Konsole/-Navigation (TP2 §2) — leerer Baum.
  return []
}
